import { authConfig } from "../apiConfig";

// FOR  GET  FREQUENCY INFORMATION FOR SCHEDULE
export const get_frequency = async () => {
    try {
        const response = await authConfig.post(`getallFrequency`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// FOR  GET  report status
export const get_report_status = async () => {
    try {
        const response = await authConfig.post(`getReportstatus`);
        return response.data;
    } catch (error) {
        throw error;
    }
};


// FOR  GET MODULE AND EVENT VALUES FOR AUDIT LOG
export const get_module_and_event_values = async () => {
    try {
        const response = await authConfig.post(`getDistinctEventDoneAndAffectedModules`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
